/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable eqeqeq */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Snackbar,
  Formatter,
  WebRequest,
  Badge,
} from '@cgn/framework-ui-components/v1';
import classNames from 'classnames';
import smoothscroll from '../../Shared/smoothscroll';
import InviaRisposta from './InviaRisposta';
import Voto from './Voto';
import Utils from '../../Shared/Utils';
import Intestazione from './conversazione/Intestazione';
import { withEventiServer } from '../../Shared/EventiServer/EventiServerContext';
import { messaggiServerEnum } from '../../Exports/iframeComunication';
import { sanitize } from '../../utils/dom/utils';

const CampoAux = ({ etichetta, valore }) => {
  if (!etichetta) return null;
  return (
    <React.Fragment>
      &nbsp; | &nbsp;
      <strong>{etichetta}:</strong> {valore}
    </React.Fragment>
  );
};

class Conversazione extends Component {
  eventiServerSubscriptions = [];

  constructor(props) {
    super(props);

    this.state = {
      conversazione: [],
      allegatiRisposta: [],
      allegatiPratiche: [],
      risposta: '',
      mostraVota: false,
    };
  }

  componentDidMount() {
    const { eventiServerContext } = this.props;

    this.eventiServerSubscriptions = [
      eventiServerContext.subscribe(messaggiServerEnum.RispostaInviata, this.aggiornaConversazione),
      eventiServerContext.subscribe(messaggiServerEnum.PrerispostaInviata, this.aggiornaConversazione),
      eventiServerContext.subscribe(messaggiServerEnum.PraticaPresaInCarico, this.aggiornaConversazione),
      eventiServerContext.subscribe(messaggiServerEnum.PraticaChiusa, this.aggiornaConversazione),
      eventiServerContext.subscribe(messaggiServerEnum.AssociatiFileAllegatiAllaReplica, this.aggiornaConversazione),
      eventiServerContext.subscribe(messaggiServerEnum.AssociatiFileAllegatiAllaPrerisposta, this.aggiornaConversazione),
      eventiServerContext.subscribe(messaggiServerEnum.AssociatiFileAllegatiAllaRisposta, this.aggiornaConversazione),
    ];
    this.caricaConversazione(this.props.pratica.IdPratica);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(next) {
    if (
      next.pratica.IdPratica != this.props.pratica.IdPratica
      || this.props.stato != next.stato
      || this.props.pratica.Aperta != next.pratica.Aperta
    ) {
      this.caricaConversazione(next.pratica.IdPratica);
    }
  }

  componentWillUnmount() {
    this.eventiServerSubscriptions.forEach((unsubscribeFunc) => { unsubscribeFunc(); });
  }

  caricaConversazione = (idPratica) => {
    WebRequest.get(`${this.props.baseUrl}/Pratica/Conversazione`, {
      idPratica,
    }).then((messaggio) => {
      this.setState({ conversazione: messaggio, mostraVota: false }, () => setTimeout(() => {
        this.conversazione
          && smoothscroll(
            this.fondoConversazione,
            500,
            null,
            this.conversazione,
          );
      }, 50));

      const allegati = [];
      messaggio.forEach((x) => {
        if (x.NumeroAllegati > 0) {
          WebRequest.get(`${this.props.baseUrl}/Pratica/AllegatiMessaggio`, {
            idMessaggio: x.IdMessaggio,
          }).then((a) => {
            allegati[x.IdMessaggio] = a;
            this.setState({ allegatiPratiche: allegati });
          });
        }
      });
    });
  };

  aggiornaConversazione = (payload) => {
    const idPratica = payload.AggregateId;
    if (idPratica == this.props.pratica.IdPratica) {
      this.caricaConversazione(idPratica);
    }
  };

  rispondi = () => {
    if (this.state.risposta && this.state.risposta != '') {
      return WebRequest.post(`${this.props.baseUrl}/Pratica/Replica`, {
        Cognome: this.props.profilo.Cognome,
        IdPratica: this.props.pratica.IdPratica,
        IdUtente: this.props.ufficioSelezionato,
        Nome: this.props.profilo.Nome,
        TestoReplica: sanitize(this.state.risposta),
      }).then((res) => {
        if (!res.Success) {
          Snackbar.show({
            type: Snackbar.Types.ERROR,
            message: res.DetectedProblems,
          });
        } else {
          this.props.onAggiornaListaQuesiti();
          this.caricaConversazione(this.props.pratica.IdPratica);
          Snackbar.show({
            type: Snackbar.Types.SUCCESS,
            message: 'Messaggio inviato con successo',
          });
          this.setState({ risposta: '', allegatiRisposta: [] });
        }
      });
    }
    return undefined;
  };

  onFileCaricato = (res, file) => {
    if (res.GuidAllegato) {
      this.setState({
        allegatiRisposta: this.state.allegatiRisposta.concat({
          guidAllegato: res.GuidAllegato,
          idAllegato: res.IdAllegato,
          nomeFile: file.name,
        }),
      });
      setTimeout(() => Snackbar.clear(), 200);
    } else {
      res.DetectedProblems.map((err) => Snackbar.aggiungiErroreAOperazione(1, err));
      Snackbar.aggiornaProgressoOperazione(1, 1);
    }
  };

  rimuoviAllegato = (idAllegato, idPratica) => {
    WebRequest.post(`${this.props.baseUrl}/Pratica/EliminaAllegato`, {
      IdAllegato: idAllegato,
      IdPratica: idPratica,
    }).then((res) => {
      if (res.Success) {
        this.setState({
          allegatiRisposta: this.state.allegatiRisposta.filter(
            (x) => x.idAllegato != idAllegato,
          ),
        });
      } else {
        Snackbar.show({
          type: Snackbar.Types.ERROR,
          message: "Errore nella rimozione dell'allegato",
        });
      }
    });
  };

  vota = (idPratica, voto, commento) => WebRequest.post(`${this.props.baseUrl}/Pratica/Vota`, {
    Nome: this.props.profilo.Nome,
    Cognome: this.props.profilo.Cognome,
    Commento: commento,
    IdPratica: idPratica,
    IdUtente: this.props.ufficioSelezionato,
    Voto: voto,
  }).then((res) => {
    if (!res.Success) {
      Snackbar.show({
        type: Snackbar.Types.ERROR,
        message: res.DetectedProblems,
      });
    } else {
      Snackbar.show({
        type: Snackbar.Types.SUCCESS,
        message: 'Voto inviato con successo',
      });
      if (this.props.pratica.Aperta) {
        this.props.router
          && this.props.router.push(
            `/messaggi/quesiti/chiusi/quesito/${idPratica}`,
          );
      } else {
        this.caricaConversazione(this.props.pratica.IdPratica);
      }
      this.props.onAggiornaPratica();
    }
  });

  stampa = () => {
    window.print();
  };

  render() {
    const classes = classNames(
      'quesiti__conversazione printable',
      { lista: !this.props.pratica.Aperta },
      { 'lista--conRispondi': this.props.pratica.Aperta },
    );
    const votabile = this.state.conversazione.filter((x) => x.Utente == 1).length > 0;
    let utente = -1;

    if (this.state.conversazione.length > 0) {
      let pos = 1;
      utente = this.state.conversazione[this.state.conversazione.length - pos].Utente;
      while (utente == -1) {
        pos += 1;
        utente = this.state.conversazione[this.state.conversazione.length - pos]
          .Utente;
      }
    }

    return (
      <div style={{ height: '100%', position: 'relative' }}>
        <Intestazione
          pratica={this.props.pratica}
          disabilitaStampa={this.props.disabilitaStampa}
          onStampa={this.stampa}
        />
        <ul
          className={classes}
          ref={(lista) => {
            this.conversazione = lista;
          }}
          id="printable"
        >
          <div className="printOnly">
            <strong>Servizio: {this.props.pratica.Servizio}</strong> &nbsp; |
            &nbsp;
            <strong>Categoria: {this.props.pratica.Categoria}</strong>
            <CampoAux
              etichetta={this.props.pratica.EtichettaCampoAux1}
              valore={this.props.pratica.CampoAux1}
            />
            <CampoAux
              etichetta={this.props.pratica.EtichettaCampoAux2}
              valore={this.props.pratica.CampoAux2}
            />
            <br />
            <span
              dangerouslySetInnerHTML={{ __html: this.props.pratica.Titolo }}
            />
          </div>

          {this.state.conversazione.map((x, i) => {
            const listClasses = classNames('quesiti__testoConversazione', {
              operatore: x.IdOperatore != null && x.IdOperatore != -1,
              sistema: x.IdOperatore == -1,
            });
            return (
              // eslint-disable-next-line react/no-array-index-key
              <li className={listClasses} key={i}>
                <span className="quesiti__quesitoTitolo">
                  <strong>
                    {x.IdOperatore == null
                      ? 'Associato'
                      : x.IdOperatore != -1
                        ? 'Operatore'
                        : ''}{' '}
                    {x.Nome} {x.IdOperatore == null && x.Cognome}
                  </strong>
                </span>{' '}
                - <Formatter valore={x.DataInvio} tipo="date" /> -{' '}
                <Formatter valore={x.DataInvio} tipo="hour" />
                <p
                  className="quesito__testoRisposta"
                  dangerouslySetInnerHTML={{
                    __html: x.Corpo.replace(
                      /Pratica\/Immagine/g,
                      `${this.props.urlHelpdesk}/Pratica/Immagine`,
                    ),
                  }}
                  onClick={Utils.navigaLink}
                />
                {this.state.allegatiPratiche[x.IdMessaggio]
                  && this.state.allegatiPratiche[x.IdMessaggio].map((allegato) => (
                    <a
                      href={`${this.props.baseUrl}/Pratica/Allegato?guidAllegato=${allegato.GuidAllegato}`}
                      target="_blank"
                      key={allegato.IdAllegato}
                      rel="noreferrer"
                    >
                      <Badge info key={allegato.IdAllegato} onClose={() => { }}>
                        {allegato.Nome}
                      </Badge>
                    </a>
                  ))}
              </li>
            );
          })}

          <div className="printOnly" style={{ textAlign: 'center' }}>
            <span>
              Gli autori declinano ogni responsabilità relativa a eventuali
              errori, omissioni o inesattezze dei contenuti presenti
              nell&apos;Assistente CGN e nelle risposte ai quesiti telematici.
              La riproduzione anche parziale dei contenuti è vietata.
            </span>
          </div>

          <span
            ref={(span) => {
              this.fondoConversazione = span;
            }}
          />
          {!this.props.pratica.Aperta
            && this.props.pratica.Storicizzata == false
            && this.props.pratica.Voto == null
            && (
              <div className="quesiti__quesitoVota noPrint">
                <br />
                <br />
                <Button
                  primary
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ mostraVota: !this.state.mostraVota });
                  }}
                >
                  {' '}
                  Vota{' '}
                </Button>
              </div>
            )}
        </ul>

        {this.props.pratica.Aperta
          && this.props.pratica.Storicizzata == false
          && (
            <InviaRisposta
              risposta={this.state.risposta}
              ref={(r) => {
                this.inviaRisposta = r;
              }}
              onRispostaModificata={(e) => this.setState({ risposta: e.target.value })}
              allegatiRisposta={this.state.allegatiRisposta}
              pratica={this.props.pratica}
              onRimuoviAllegato={(idAllegato) => this.rimuoviAllegato(idAllegato, this.props.pratica.IdPratica)}
              onVota={this.vota}
              uploadUrl={`${this.props.baseUrl}/Pratica/Allega?idPratica=${this.props.pratica.IdPratica}`}
              onFileCaricato={(res, nomeFile) => this.onFileCaricato(res, nomeFile)}
              onRispondi={() => this.rispondi()}
              mostraMessaggioVoto={votabile}
              ultimoMessaggioUtente={utente % 2 == 0}
              stampa={this.stampa}
              haAlmenoUnaRisposta={this.state.conversazione.some(
                (x) => x.IdOperatore && x.Nome != 'Sistema',
              )}
            />
          )}

        <Voto
          show={this.state.mostraVota}
          voto={this.props.pratica.Voto}
          idPratica={this.props.pratica.IdPratica}
          onVota={(idPratica, voto, commento) => this.vota(idPratica, voto, commento).then((res) => this.setState({ mostraVota: false }))}
          onClose={() => this.setState({ mostraVota: false })}
        />
      </div>
    );
  }
}

Conversazione.propTypes = {
  baseUrl: PropTypes.string,
  pratica: PropTypes.shape({
    IdPratica: PropTypes.string.isRequired,
    Aperta: PropTypes.bool,
    Servizio: PropTypes.string,
    Categoria: PropTypes.string,
    Voto: PropTypes.number,
    Titolo: PropTypes.string,
    Storicizzata: PropTypes.bool,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
    CampoAux1: PropTypes.string,
    CampoAux2: PropTypes.string,
  }).isRequired,
  stato: PropTypes.string.isRequired,
  onAggiornaListaQuesiti: PropTypes.func.isRequired,
  onAggiornaPratica: PropTypes.func.isRequired,
  profilo: PropTypes.shape({
    Nome: PropTypes.string.isRequired,
    Cognome: PropTypes.string.isRequired,
  }).isRequired,
  ufficioSelezionato: PropTypes.string.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  disabilitaStampa: PropTypes.bool.isRequired,
  urlHelpdesk: PropTypes.string.isRequired,
  eventiServerContext: PropTypes.shape({
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
  }).isRequired,
};

Conversazione.defaultProps = {
  baseUrl: '',
};

export default withEventiServer(Conversazione);
